/* global google */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import loadGoogleMapsApi from 'load-google-maps-api';

import { distance } from '_utils';
import { fetchEvents } from '_redux/actioncreators/events';
import { mapDataToMarkers, getMarkerIcon, getUserMarker, getMapOptions } from './map-settings';

import MapSearch from './MapSearch';


class Map extends Component {
  constructor(props) {
    super();

    props.fetchEvents(props.cultureCode);

    this.state = {
      userLocation: null,
      mapHasInit: false,
      googleMapsLoaded: false,
    };

    loadGoogleMapsApi({
      libraries: ['places'],
      key: 'AIzaSyAn1bexVAEij-DjZ0swOqGteoRtUFt4OTE',
    }).then(() => this.setState({
      googleMapsLoaded: true,
    }));

    this.mapElement = React.createRef();
  }

  componentDidUpdate() {
    if (this.state.googleMapsLoaded === false) {
      return;
    }

    if (this.props.page.contentLoading === true) {
      return;
    }

    if (this.state.mapHasInit === true) {
      return;
    }

    this.initialiseMap();
    this.setState({
      mapHasInit: true,
    });

    this.promptUserLocation();
  }

  render() {
    if (this.props.page.contentLoading === true || this.state.googleMapsLoaded === false) {
      return null;
    }

    return (
      <div className="map-container">
        <MapSearch promptUserLocation={this.promptUserLocation} setMapToPlace={this.setMapToPlace} setMapToMarkerLocation={this.setMapToMarkerLocation}>
        </MapSearch>
        <div ref={this.mapElement} className="map"></div>
      </div>
    );
  }

  initialiseMap = () => {
    const locations = mapDataToMarkers(this.props.page.content.eventLocations);
    this.markers = this.getMapMarkers(locations);

    this.userLocationMarker = new google.maps.Marker({
      icon: getUserMarker(),
      position: null,
      map: null,
      zIndex: 100,
    });

    this.map = new google.maps.Map(this.mapElement.current, getMapOptions());
    this.setMapToMarkerLocation();
  }

  setMapToUserLocation = (location) => {
    const bounds = new google.maps.LatLngBounds();

    this.userLocationMarker.setMap(this.map);
    this.userLocationMarker.setPosition(location);

    // Add the user marker to the bounds
    bounds.extend(this.userLocationMarker.position);

    // Order by distance from the user
    this.markers.sort((a, b) => {
      const dis1 = distance(location.lat, location.lng, a.position.lat(), a.position.lng());
      const dis2 = distance(location.lat, location.lng, b.position.lat(), b.position.lng());

      if (dis1 < dis2) {
        return -1;
      }

      if (dis1 > dis2) {
        return 1;
      }

      return 0;
    });

    // Get the first two locations and include those in the bounds.
    for (let i = 0; i < this.markers.length; i++) {
      const marker = this.markers[i];

      if (i <= 1) {
        bounds.extend(marker.position);
      }

      marker.setMap(this.map);
    }

    this.map.fitBounds(bounds);
  }

  setMapToMarkerLocation = () => {
    const bounds = new google.maps.LatLngBounds();

    for (let i = 0; i < this.markers.length; i++) {
      const marker = this.markers[i];
      marker.setMap(this.map);
      bounds.extend(marker.position);
    }

    this.map.fitBounds(bounds);
  }

  setMapToPlace = (place) => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ placeId: place.place_id }, (res) => {
      const location = {
        lat: res[0].geometry.location.lat(),
        lng: res[0].geometry.location.lng(),
      };
      this.setMapToUserLocation(location);
    });
  }

  getMapMarkers(locations) {
    const markers = [];

    const infowindow = new google.maps.InfoWindow();

    for (let i = 0; i < locations.length; i++) {
      const location = locations[i];

      const marker = new google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        icon: getMarkerIcon(),
      });

      marker.addListener('click', () => {
        infowindow.setContent(location.info);
        infowindow.setPosition(marker.position);
        infowindow.open(this.map, marker);
      });

      markers.push(marker);
    }

    return markers;
  }

  promptUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => this.setMapToUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }));
    }
  }
}

const mapStateToProps = state => ({
  page: state.app.events,
});

const mapDispatchToProps = dispatch => ({
  fetchEvents: cultureCode => dispatch(fetchEvents({ cultureCode })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);
